import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
  User,
} from "firebase/auth";

const auth = getAuth();

export function authListener(cb: (user: User | null) => any) {
  return onAuthStateChanged(auth, cb);
}

export async function loginAsync(email: string, password: string) {
  return signInWithEmailAndPassword(auth, email, password);
}
export async function registerAsync(email: string, password: string) {
  return createUserWithEmailAndPassword(auth, email, password);
}
export function logoutAsync(cb: () => any) {
  const userId = auth.currentUser?.uid;
  if (userId) {
    // cb();
  }
  return signOut(auth);
}

export function sendPasswordResetLinkAsync(email: string) {
  return sendPasswordResetEmail(auth, email);
}

export async function updatePasswordAsync(password: string) {
  if (auth.currentUser) {
    return updatePassword(auth.currentUser, password);
  }
  return null;
}

export default auth;
